import { TicketLogChannel } from '@shared/enums/ticket-log';

export let Constants = {

  userType: Object.freeze({
    admin: 'ADMIN',
    dealer: 'DEALER',
    dealerManager: 'DEALER_MANAGER',
    agent: 'AGENT',
    ussi: 'USSI',
    ussiAdmin: 'USSI_ADMIN',
    be: 'BE',
    beAdmin: 'BE_ADMIN',
    ra: 'RA',
    raAdmin: 'RA_ADMIN',
  }),

  escalationType: Object.freeze([
    { code: 'INQUIRY', value: 'INQUIRY' },
    { code: 'TRACKING_STATUS', value: 'TRACKING_STATUS' },
    { code: 'SYSTEM_ISSUE', value: 'SYSTEM_ISSUE' },
    { code: 'OTHER', value: 'OTHER' },
  ]),

  escalationStatus: Object.freeze({
    REQUESTED: 'REQUESTED',
    NOTIFIED: 'NOTIFIED',
    CANCELED: 'CANCELED',
    IN_PROGRESS: 'IN_PROGRESS',
    RESOLVED: 'RESOLVED',
  }),

  role: Object.freeze({
    ADMIN: 'Admin',
    ADMIN_VIEWER: 'Admin Viewer',
    ADMIN_SELECT: 'Admin Select',
    CD_ADMIN: 'CD Admin',
    DEALER: 'Dealer',
    DEALER_MANAGER: 'Dealer Manager',
    AGENT: 'Agent',
    DEALER_AGENT: 'Dealer Agent',
    CD_AGENT: 'CD Agent',
    CD_STORE: 'CD Store',
    USSI: 'USSI',
    USSI_ADMIN: 'USSI Admin',
    BE: 'BE',
    RA: 'Military',
    BE_ADMIN: 'BE Admin',
    RA_ADMIN: 'Military Admin',
    DEALER_STAFF: 'Dealer Staff',
    DEALER_SUPERVISOR: 'Dealer Manager',
    SYS_ADMIN: 'Sys Admin',
    BIZ_ADMIN: 'Biz Admin',
  }),

  entryPath: Object.freeze({
    TicketManager: 'TicketManager',
    ClickTab: 'ClickTab',
  }),

  ticketMasterType: Object.freeze({
    Agent: 'Agent',
    Dealer: 'Dealer',
    Status: 'Status',
  }),

  ticketMasterField: Object.freeze({
    Agent: {
      field: ['Agent', 'Active'],
      inbound: false,
    },
    Dealer: {
      field: ['Store', 'Active'],
      inbound: false,
    },
    Status: {
      field: ['Status', '#'],
      inbound: false,
    }
  }),

  detailType: Object.freeze({
    REPAIR: {
      code: 'DET001',
      name: 'Repair',
    },
    EXCHANGE: {
      code: 'DET002',
      name: 'Exchange',
    },
    REFUND: {
      code: 'DET003',
      name: 'Refund',
    },
    NCP: {
      code: 'DET004',
      name: 'NCP',
    },
    COMPENSATION: {
      code: 'DET005',
      name: 'Compensation',
    },
  }),

  dealerStatus: Object.freeze({
    REQUESTED: {
      code: 'REQUESTED',
      name: 'REQUESTED'
    },
    ACTIVE: {
      code: 'ACTIVE',
      name: 'ACTIVE'
    },
    INACTIVE: {
      code: 'INACTIVE',
      name: 'INACTIVE'
    },
  }),

  gcicStatus: Object.freeze({
    NO_COVERAGE: {
      code: 'ST005',
      name: 'No Coverage',
    },
    ASSIGNED: {
      code: 'ST010',
      name: 'Assigned to Service Center',
    },
    ACKNOWLEDGE: {
      code: 'ST015',
      name: 'Acknowledge (Service Center)',
    },
    PRODUCT_RECEIVED: {
      code: 'ST020',
      name: 'Product Received',
    },
    ENGINEER_ASSIGNED: {
      code: 'ST025',
      name: 'Technician Assigned',
    },
    PENDING: {
      code: 'ST030',
      name: 'Pending',
    },
    ASC_DECLINED: {
      code: 'ST033',
      name: 'Service Center Declined',
    },
    REPAIR_COMPLETED: {
      code: 'ST035',
      name: 'Repair Completed',
    },
    GOODS_DELIVERED: {
      code: 'ST040',
      name: 'Goods Delivered',
    },
    CANCELLED_BY_TRIAGE: {
      code: 'ST050',
      name: 'Cancelled by Triage group(Field Service)',
    },
    CANCELLED_BY_AGENT: {
      code: 'ST051',
      name: 'Cancelled by Agent',
    },
    CANCELLED_BY_ASC: {
      code: 'ST052',
      name: 'Cancelled by Service Center',
    },
    WARRANTY_CLAIMED: {
      code: 'ST055',
      name: 'Warranty Claimed',
    },
    HAPPY_CALL: {
      code: 'ST060',
      name: 'Happy Call',
    },
    SR_CANCEL: {
      code: 'E0003',
      name: 'Cancel',
      reason: 'PFDS',
    },
    SR_COMPLETE: {
      code: 'E0004',
      name: 'Cancel',
      reason: 'TTSC'
    },
    SR_PENDING: {
      code: 'E0001',
      name: 'Pending',
      reason: 'TTSC'
    },
  }),

  gcic4kEditableStatus: [
    'ST005', 'ST010', 'ST015', 'ST020', 'ST025', 'ST030', 'ST033'
  ],

  purchasePlace: Object.freeze({
    BUILDER: '40',
  }),

  gcicStatusCode: Object.freeze({
    ST005: 'No Coverage',
    ST010: 'Assigned to Service Center',
    ST015: 'Acknowledge (Service Center)',
    ST020: 'Product Received',
    ST025: 'Technician Assigned',
    ST030: 'Pending',
    ST033: 'Service Center Declined',
    ST035: 'Repair Completed',
    ST040: 'Goods Delivered',
    ST050: 'Cancelled by Triage group(Field Service)',
    ST051: 'Cancelled by Agent',
    ST052: 'Cancelled by Service Center',
    ST055: 'Warranty Claimed',
    ST060: 'Happy Call',
    E0001: 'Pending',
    E0002: 'Transfer',
    E0003: 'Cancel',
    E0004: 'Closed',
    ES005: 'Exchange Order Created',
    ES010: 'Waiting for GRMS/RMA approval',
    ES015: 'GRMS/RMA approved',
    ES020: 'S/O Created',
    ES025: 'D/O Created',
    ES030: 'Order Shipped / In-Transit',
    ES040: 'Delivered',
    ES080: 'Cancel',
    ES090: 'Reject',
  }),

  gcicStatusCodeForProgress: Object.freeze({
    ST005: 'No Coverage',
    ST010: 'Assigned to Service Center',
    ST015: 'Acknowledge (Service Center)',
    ST020: 'Product Received',
    ST025: 'Technician Assigned',
    ST030: 'Pending',
    ST033: 'Service Center Declined',
    ST035: 'Repair Completed',
    ST040: 'Goods Delivered',
    ST050: 'Cancelled by Triage group(Field Service)',
    ST051: 'Cancelled by Agent',
    ST052: 'Cancelled by Service Center',
    ST055: 'Warranty Claimed',
    ST060: 'Happy Call',
    E0001: 'Pending',
    E0002: 'Transfer',
    E0003: 'Cancel',
    E0004: 'Closed',
    ES005: 'Exchange Order Created',
    ES010: 'Waiting for GRMS/RMA approval',
    ES015: 'GRMS/RMA approved',
    ES020: 'S/O Created',
    ES025: 'D/O Created',
    ES030_IN_TRANSIT: 'In-Transit',
    ES030_DELIVERED: 'Delivered',
    ES030_COMPLETE: 'Exchange Complete',
    ES040: 'Exchange Complete',
    ES080: 'Cancel',
    ES090: 'Reject',
    REJECT: 'Request Rejected',
  }),

  serviceCode: Object.freeze({
    PICKUP_SERVICE: 'PS',
    DEMO_SERVICE: 'DM',
    IN_HOME: 'IH',
    STOCK_REPAIR: 'SR',
    COSMETIC_REPAIR: 'SI',
    INSTALL_CHECKING: 'IN',
  }),

  serviceTypeWithName: Object.freeze([
    { company: 'C310', code: 'PS', name: 'Depot Repair' },
    { company: 'C370', code: 'PS', name: 'Pickup Service' },
    { company: 'C310', code: 'DM', name: 'Demo Repair' },
    { company: 'C330', code: 'IH', name: 'In-Home Repair' },
    { company: 'C310', code: 'IH', name: 'Functional Repair' },
    { company: 'C310', code: 'SR', name: 'Stock Repair' },
    { company: 'C310', code: 'SI', name: 'Cosmetic Repair' },
    { company: 'C310', code: 'IN', name: 'Installing Checking' },
    { company: 'C310', code: 'CI', name: 'Carry In' },
    { company: 'C310', code: 'BS', name: 'Before Service' },
    { company: 'C310', code: 'ER', name: 'Exchange Repair' },
    { company: 'C310', code: 'FC', name: 'FSC Carry In' },
    { company: 'C310', code: 'II', name: 'Initial Installation' },
    { company: 'C310', code: 'IS', name: 'Inspection' },
    { company: 'C310', code: 'KT', name: 'Kit Repair' },
    { company: 'C310', code: 'MX', name: 'Monitor Exchange' },
    { company: 'C310', code: 'PD', name: 'Product Discount' },
    { company: 'C310', code: 'PF', name: 'Phone Fix' },
    { company: 'C310', code: 'PL', name: 'Product Liability' },
    { company: 'C310', code: 'PR', name: 'Product Return' },
    { company: 'C310', code: 'RB', name: 'Refurbishing' },
    { company: 'C310', code: 'RC', name: 'Recall' },
    { company: 'C310', code: 'RH', name: 'Return Handling' },
    { company: 'C310', code: 'RL', name: 'Return Logistics cost' },
    { company: 'C310', code: 'SC', name: 'Stock Repair ? Carry In' },
    { company: 'C310', code: 'SE', name: 'Swap & Exchange Repair' },
    { company: 'C310', code: 'SH', name: 'Service Handling' },
    { company: 'C310', code: 'SP', name: 'Service Point' },
    { company: 'C310', code: 'SW', name: 'Set Swap' },
    { company: 'C310', code: 'AD', name: 'Accidental Damage Handling' },
  ]),

  customerType: Object.freeze({
    CUSTOMER: 'Customer',
    STORE: 'Store',
  }),

  concealedDamageReportType: Object.freeze({
    CD: { code: 'CD', name: 'Concealed Damage' },
    SS: { code: 'SS', name: 'Stock Screening' },
  }),

  concealedTypeType: Object.freeze({
    NOT_ELIGIBLE: { code: 'NOT_ELIGIBLE', name: 'Not Eligible' },
    SELF_INSPECTION: { code: 'SELF_INSPECTION', name: 'Self Inspection' },
    SAMSUNG_INSPECTION: { code: 'SAMSUNG_INSPECTION', name: 'Samsung Inspection' },
    SELF_SAMSUNG: { code: 'SELF_SAMSUNG', name: 'Self/Samsung Inspection' },
  }),

  concealedDamageStatus: Object.freeze({
    DRAFT: { code: 'DRAFT', name: 'Drafted' },
    REVIEW: { code: 'REVIEW', name: 'Review Requested' },
    CSD_REJECT: { code: 'REJECT', name: 'Rejected by CSD' },
    DATA: { code: 'DATA', name: 'Data Requested' },
    CSD_APPROVE: { code: 'PROCESS', name: 'In process' },
    RA_APPROVE: { code: 'APPROVE', name: 'Approved' },
    RA_REJECT: { code: 'RA-REJECT', name: 'Rejected' },
    COMPLETE: { code: 'COMPLETE', name: 'Completed' },
    NA: { code: 'NA', name: 'No RA required' },
  }),
  concealedApprovalReason: Object.freeze({
    CSD: { code: 'CSD', name: 'Approved by CSD data review' },
    PUMI: { code: 'PUMI', name: 'Approved by PUMI' },
  }),

  specialAsc: Object.freeze({
    NO_ASC: {
      ascNo: '999999',
      name: 'No ASC Available',
    },
    NO_ASC_FOR_SI: {
      ascNo: '888888',
      name: 'No Service Center Available For SI',
    },
    DECLINED: {
      ascNo: '555555',
      name: 'ASC Declined',
    },
    ASC_FOR_LENNAR: {
      bpNo: '5082162973',
      ascNo: '888888',
      name: 'ASC For Lennar',
    },
  }),

  logParty: Object.freeze([{
    code: 'LOG',
    name: 'Log',
    channel: TicketLogChannel.Log,
    to: 'NONE',
    role: ['AGENT', 'ADMIN', 'SYSADMIN']
  }, {
    code: 'email',
    name: 'Email to Customer',
    channel: TicketLogChannel.Email,
    to: 'CUSTOMER',
    role: ['DEALER', 'AGENT', 'ADMIN', 'SYSADMIN']
  }, {
    code: 'escalation',
    name: 'Escalation',
    channel: TicketLogChannel.Log,
    to: 'SEA',
    role: ['DEALER', 'ADMIN', 'SYSADMIN', 'AGENT']
  }, {
    code: 'enr',
    name: 'ENR Request',
    channel: TicketLogChannel.GCIC,
    to: 'SEA',
    role: ['DEALER']
  }, {
    code: 'ncp',
    name: 'NCP Request',
    channel: TicketLogChannel.GCIC,
    to: 'SEA',
    role: ['DEALER']
  }, {
    code: 'reply',
    name: 'Reply to Escalation',
    channel: TicketLogChannel.Email,
    to: 'DEALER',
    role: ['AGENT', 'ADMIN', 'SYSADMIN']
  }]),

  processType: Object.freeze({
    GA: 'ZC01',     // 1K (GA)
    TA: 'ZC11',     // 2K (TA)
    VOC: 'ZV01',    // 3K
    SR: 'ZR01',     // 5K
    SO: 'ZS01',     // 4k
  }),

  dummyASCs: Object.freeze([
    '999999',
    '888888',
    '555555',
    '5555555',
  ]),

  companies: Object.freeze([
    { code: 'C310', name: 'SEA', image: 'flag-usa.png', country: 'us', products: ['ce'] },
    { code: 'C370', name: 'SEA MX', image: 'flag-usa.png', country: 'us', products: ['mx'] },
    { code: 'C330', name: 'SECA', image: 'flag-canada.png', country: 'ca', products: ['ce', 'mx'] },
  ]),

  countries: Object.freeze([
    { code: 'us', name: 'USA' },
    { code: 'ca', name: 'Canada' }
  ]),

  products: Object.freeze([
    { code: 'ce', name: 'Home Appliance' },
    { code: 'mx', name: 'Mobile/Tablet' }
  ]),

  canadaProvinces: Object.freeze([
    { code: 'AB', name: 'Alberta (AB)' },
    { code: 'BC', name: 'British Columbia (BC)' },
    { code: 'MB', name: 'Manitoba (MB)' },
    { code: 'NB', name: 'New Brunswick (NB)' },
    { code: 'NL', name: 'Newfoundland and Labrador (NL)' },
    { code: 'NS', name: 'Nova Scotia (NS)' },
    { code: 'ON', name: 'Ontario (ON)' },
    { code: 'PI', name: 'Prince Edward Island (AB)' },
    { code: 'QC', name: 'Quebec (QC)' },
    { code: 'SK', name: 'Saskatchewan (SK)' },
    { code: 'NT', name: 'Northwest Territories (NT)' },
    { code: 'YT', name: 'Yukon (YT)' },
    { code: 'NU', name: 'Nunavut (NU)' },
  ]),

  B2bWorkFlowStatus: Object.freeze({
    NOT_SUBMITTED: {
      code: 'NOT_SUBMITTED',
      name: 'NOT_SUBMITTED'
    },
    REQUESTED: {
      code: 'REQUESTED',
      name: 'REQUESTED'
    },
    APPROVED: {
      code: 'APPROVED',
      name: 'APPROVED'
    },
    REJECTED: {
      code: 'REJECTED',
      name: 'REJECTED'
    },
  }),

  b2bStatus: Object.freeze({
    REQUESTED: {
      code: 'REQUESTED',
      name: 'REQUESTED'
    },
    ACTIVE: {
      code: 'ACTIVE',
      name: 'ACTIVE'
    },
    INACTIVE: {
      code: 'INACTIVE',
      name: 'INACTIVE'
    },
  }),

  b2bExchangeOptions: Object.freeze([
    {
      code: 'OOBF',
      name: 'OOBF'
    },
    {
      code: 'FT,FT/WG',
      name: 'FT, FT/WG'
    },
    {
      code: 'StandardExchange',
      name: 'Standard Exchange'
    },
  ]),

  partnerOrganizationList: Object.freeze([
    {
      code: 'SVQ',
      name: 'SVQ'
    },
    {
      code: 'USSI',
      name: 'USSI'
    },
    {
      code: 'NISH',
      name: 'NISH'
    },
    {
      code: 'HSN',
      name: 'HSN'
    },
    {
      code: 'TECHEIM',
      name: 'TECHEIM'
    },
    {
      code: 'TTS',
      name: 'TTS'
    },
  ]),

  b2bPartnerOrganizations: Object.freeze({
    USSI: 'USSI',
    SVQ: 'SVQ',
  }),

  b2bTicketCompleteStatus: Object.freeze([
    'ES030', 'ES040', 'ES080', 'ES090'
  ]),

  b2bTicketCancelStatus: Object.freeze([
    'ES080'
  ]),

  b2bTicketCompleteStatusExcludingES030: Object.freeze([
    'ES040', 'ES080', 'ES090'
  ]),

  b2bTicketEditableStatus: Object.freeze([
    'ES005', 'ES010', 'ES015', 'ES020', 'ES025', 'ES030', 'ES035', 'ES040'
  ]),

  b2bTicketSimpleUpdatableStatus: Object.freeze([
    'ES015', 'ES020', 'ES025', 'ES030', 'ES035', 'ES040'
  ]),

  b2bTicketRmaNoEditableStatus: Object.freeze([
    'ES030', 'ES040'
  ]),

  b2bTicketSerialNoEditableStatus: Object.freeze([
    'ES020', 'ES025', 'ES030', 'ES040'
  ]),

  b2bTicketAfterSoDropStatus: Object.freeze([
    'ES025', 'ES030', 'ES035', 'ES040'
  ]),

  B2bExchangeTrackingStatus: Object.freeze({
    IN_TRANSIT: 'IN_TRANSIT',
    DELIVERED: 'DELIVERED',
    PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
    PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
  }),

  B2bReturnTrackingStatus: Object.freeze({
    PICKUP_REQUESTED: 'PICKUP_REQUESTED',
    IN_TRANSIT: 'IN_TRANSIT',
    PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
    COMPLETELY_DELIVERED: 'COMPLETELY_DELIVERED',
    PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
    COMPLETED: 'COMPLETED',
  }),

  B2bRsmEscalationStatusCodes: Object.freeze({
    PENDING: 'PENDING',
    REQUESTED: 'REQUESTED',
    APPROVED: 'APPROVED',
    APPROVED_EXCHANGE: 'APPROVED_EXCHANGE',
    REJECTED: 'REJECTED',
    ERROR: 'ERROR',
  }),

  Tpa: Object.freeze({
    SFMMC: { code: 'B', name: 'SFMMC' },
    ASSURANT: { code: '2', name: 'Assurant' }
  }),

  ConcealedDamageProductType: Object.freeze([
    { code: '01', name: 'TV' },
    { code: '08', name: 'TV' },
    { code: '09', name: 'Projector' },
    { code: '10', name: 'HTS' },
    { code: '16', name: 'Microwave Oven' },
    { code: '17', name: 'Microwave Oven' },
    { code: '19', name: 'Freezer' },
    { code: '19', name: 'Refrigerator' },
    { code: '28', name: 'TV' },
    { code: '29', name: 'Monitor' },
    { code: '30', name: 'Monitor' },
    { code: '40', name: 'Vacuum' },
    { code: '45', name: 'Pedestal' },
    { code: '46', name: 'Laptop' },
    { code: '47', name: 'Dishwasher' },
    { code: '48', name: 'Range' },
    { code: '49', name: 'Range' },
    { code: '51', name: 'Printer' },
    { code: '53', name: 'HTS' },
    { code: '68', name: 'Washer' },
    { code: '69', name: 'Dryer' },
    { code: '80', name: 'Refrigerator' },
    { code: '95', name: 'SSD' },
    { code: '96', name: 'Tablet' },
    { code: 'A2', name: 'TV' },
    { code: 'A5', name: 'Tablet' },
    { code: 'A7', name: 'Tablet' },
    { code: 'A9', name: 'Monitor' },
    { code: 'B1', name: 'Airdresser' },
    { code: 'D4', name: 'Oven' },
    { code: 'D4', name: 'Warming Drawer' },
    { code: 'D5', name: 'Hood' },
    { code: 'D7', name: 'Range' },
    { code: 'D8', name: 'Microwave Oven' },
    { code: 'DA', name: 'Dishwasher' },
    { code: 'DB', name: 'Cooktop' },
    { code: 'DC', name: 'Cooktop' },
    { code: 'DE', name: 'Hood' },
    { code: 'DF', name: 'Range' },
    { code: 'DG', name: 'Microwave Oven' },
    { code: 'DH', name: 'Refrigerator' },
    { code: 'DI', name: 'Refrigerator Door Panel' },
    { code: 'DJ', name: 'Wine Cellar' },
    { code: 'DL', name: 'Microwave Oven' },
    { code: 'DM', name: 'Refrigerator' },
    { code: 'W5', name: 'Tablet' },
  ]),

  trainingVideos: Object.freeze([
  { type: 'overview',index: 1, id: 'overview', title: 'Dealer Service Solutions Portal Overview', route: 'video/overview', videoUrl: 'https://bcove.video/4sGLLkl' },
  { type: 'gettingStartedItems', id: 'account-creation', index: 2, title: 'Account Creation', route: 'video/account-creation', videoUrl: 'https://bcove.video/4lu7vOa' },
  { type: 'gettingStartedItems', id: 'mfa-login', index: 3, title: 'Logging into the Portal', route: 'video/mfa-login', videoUrl: 'https://bcove.video/4utH4fy' },
  { type: 'gettingStartedItems', id: 'password-recovery', index: 4, title: 'Password Reset', route: 'video/password-recovery', videoUrl: 'https://bcove.video/4dlPTSp' },
  { type: 'gettingStartedItems', id: 'creating-stores', index: 5, title: 'Creating Stores', route: 'video/creating-stores', videoUrl: 'https://bcove.video/47KUqtY' },
  { type: 'gettingStartedItems', id: 'adding-users', index: 6, title: 'Adding Contacts', route: 'video/adding-users', videoUrl: 'https://bcove.video/4dhEUJF' },
  { type: 'ticketManagementItems', id: 'warranty-ticket', index: 7, title: 'Warranty Repair Ticket Creation', route: 'video/warranty-ticket', videoUrl: 'https://bcove.video/4rz696a' },
  { type: 'ticketManagementItems', id: 'cosmetic-ticket', index: 8, title: 'Cosmetic Repair Ticket Creation', route: 'video/cosmetic-ticket', videoUrl: 'https://bcove.video/40uGcJW' },
  { type: 'ticketManagementItems', id: 'ticket-search', index: 9, title: 'Ticket Search', route: 'video/ticket-search', videoUrl: 'https://bcove.video/47LBGun' },
  { type: 'ticketManagementItems', id: 'ticket-filters', index: 10, title: 'Using Filters', route: 'video/ticket-filters', videoUrl: 'https://bcove.video/4uoq36x' },
  { type: 'ticketManagementItems', id: 'ticket-details', index: 11, title: 'Ticket Details', route: 'video/ticket-details', videoUrl: 'https://bcove.video/3P7Zbrh' },
  { type: 'ticketManagementItems', id: 'ticket-comments', index: 12, title: 'Adding Comments to Tickets', route: 'video/ticket-comments', videoUrl: 'https://bcove.video/4sDUGTz' },
  ]),

  LED_PORTAL_URL: 'https://sea.samsungsupport.com/slap/login_B2BVD'
}
